import { useApp } from '../../context/AppContext';
import { Slider } from '../ui/slider';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { Info } from 'lucide-react';

export const SliderInput = ({ 
  label, 
  value, 
  onChange, 
  min = 0, 
  max = 100, 
  step = 1, 
  suffix = '',
  prefix = '',
  tooltip,
  testId,
}) => {
  const { theme } = useApp();
  
  const handleInputChange = (e) => {
    const newValue = parseFloat(e.target.value.replace(/[^\d.-]/g, '')) || 0;
    onChange(Math.min(max, Math.max(min, newValue)));
  };
  
  const handleSliderChange = (values) => {
    onChange(values[0]);
  };
  
  const displayValue = prefix ? `${prefix}${value.toLocaleString('ro-RO')}` : 
                       suffix ? `${value.toLocaleString('ro-RO')}${suffix}` : 
                       value.toLocaleString('ro-RO');
  
  return (
    <div className="space-y-3" data-testid={testId}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Label className="text-xs uppercase tracking-[0.15em] text-foreground/70 dark:text-foreground/80 font-semibold">
            {label}
          </Label>
          {tooltip && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Info className="h-3.5 w-3.5 text-foreground/50 cursor-help hover:text-foreground/70 transition-colors" />
                </TooltipTrigger>
                <TooltipContent 
                  side="top" 
                  className="max-w-xs bg-popover text-popover-foreground border shadow-lg"
                >
                  <p className="text-sm">{tooltip}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
        <Input
          type="text"
          value={displayValue}
          onChange={handleInputChange}
          className="w-32 text-right font-semibold h-9 text-base"
          data-testid={`${testId}-input`}
        />
      </div>
      <Slider
        value={[value]}
        onValueChange={handleSliderChange}
        min={min}
        max={max}
        step={step}
        className="cursor-pointer"
        data-testid={`${testId}-slider`}
      />
      <div className="flex justify-between text-xs text-foreground/50 dark:text-foreground/40 font-medium">
        <span>{prefix}{min.toLocaleString('ro-RO')}{suffix}</span>
        <span>{prefix}{max.toLocaleString('ro-RO')}{suffix}</span>
      </div>
    </div>
  );
};

export default SliderInput;
